<script>
import { userTypes } from "@/store/types/types.js";
import Search from "@/components/Search";
export default {
  name: "ChooseCustomer",
  data() {
    return {
      length: 0
    };
  },
  components: {
    Search
  },
  computed: {
    userList() {
      return this.$store.getters[userTypes.getters.getUserList];
    }
  },
  methods: {
    search(data) {
      if (!data.q) delete data.q;
      this.$store.dispatch(userTypes.actions.QUERY_USER_LIST, data);
    },
    chooseUser(id) {
      this.$router.push({ name: "new-order", params: { id: id } });
    }
  },
  beforeMount() {
    this.$store.dispatch(userTypes.actions.QUERY_USER_LIST);
    this.$store
      .dispatch(userTypes.actions.GET_USER_LIST_LENGTH)
      .then(length => {
        this.length = length;
      });
  }
};
</script>


<template src="./template.html"></template>
<style lang="scss" src="./style.scss" scoped/>
